import React from "react";
import { tono } from "./tonos";

/**
 * Aviso destacado del kit de tableros: una franja con el tono del semáforo,
 * un número grande, un texto y acciones (drill-down). Reemplaza los modales
 * de bienvenida que tapaban la pantalla: no bloquea, se puede cerrar y cada
 * número abre su pantalla (un tablero nunca lista filas).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {string} tonoxxx   ROJO | NARANJA | AMARILLO | VERDE | AZUL | MORADO | NAVY | GRIS
 * @param {string} kicker    Texto pequeño arriba (p. ej. "Operaciones críticas")
 * @param {number|string} valor Número grande (clic = acción principal)
 * @param {string} titulo    Frase principal
 * @param {string} texto     Detalle bajo el título
 * @param {Array} acciones   [{clave, texto, onClick, primaria}]
 * @param {function} onCerrar Si viene, pinta la ✕
 */
const Avisoxxx = ({ tonoxxx = "ROJO", kicker, valor, titulo, texto, acciones = [], onCerrar }) => {
  const t = tono(tonoxxx);
  const principal = acciones.find((a) => a.primaria) ?? acciones[0];
  return (
    <div className="tbl tbl-aviso" style={{ borderColor: t.hex, background: t.chip.background }} role="status">
      <div className="tbl-aviso-valor" style={{ color: t.hex, cursor: principal ? "pointer" : "default" }} onClick={principal?.onClick} title={principal?.texto}>
        {valor}
      </div>
      <div className="tbl-aviso-cuerpo">
        {kicker && <span className="tbl-kicker" style={{ color: t.chip.color }}>{kicker}</span>}
        <span className="tbl-aviso-titulo" style={{ color: t.chip.color }}>{titulo}</span>
        {texto && <span className="tbl-kpi-nota">{texto}</span>}
      </div>
      <div className="tbl-aviso-acciones">
        {acciones.map((a) => (
          <button key={a.clave} type="button" className={`tbl-chip clic ${a.primaria ? "" : "tbl-chip-suave"}`} style={a.primaria ? { background: t.hex, color: "#FFFFFF" } : { background: "#FFFFFF", color: t.chip.color, border: `1px solid ${t.hex}` }} onClick={a.onClick}>
            {a.texto}
          </button>
        ))}
        {onCerrar && (
          <button type="button" className="tbl-enlace" style={{ color: t.chip.color }} title="Cerrar por hoy" onClick={onCerrar}>✕</button>
        )}
      </div>
    </div>
  );
};

export default Avisoxxx;
